export const normalizeCrmPagination = (pagination = {}, fallbackLimit = 20) => {
  const page = pagination.page ?? pagination.currentPage ?? 1;
  const limit = pagination.limit ?? fallbackLimit;
  const total = pagination.total ?? pagination.totalCount ?? pagination.totalItems ?? 0;
  const pages = pagination.pages ?? pagination.totalPages ?? 0;
  return { page, limit, total, pages };
};

export const getPaginationPageNumbers = (page, pages, maxVisible = 5) => {
  if (pages <= 0) return [];
  const visible = Math.min(maxVisible, pages);
  return Array.from({ length: visible }, (_, i) => {
    if (pages <= maxVisible) return i + 1;
    if (page <= 3) return i + 1;
    if (page >= pages - 2) return pages - maxVisible + 1 + i;
    return page - 2 + i;
  });
};

/** Prevent stale paginated fetch responses from overwriting newer results. */
export const createFetchRequestGuard = () => {
  let requestId = 0;
  return {
    next: () => {
      requestId += 1;
      return requestId;
    },
    isCurrent: (id) => id === requestId
  };
};
